import type { SliceI18nManifest } from '@/shared/lib/vsa';
import cs from './locales/cs.json';
import en from './locales/en.json';

const NS = 'archival';

/**
 * Lokalizační kontrakt sdílené archival capability (banner + (de)archivační tlačítko).
 */
export const archivalI18nManifest: SliceI18nManifest = {
  owner: 'shared/archival',
  namespaces: [NS],
  resources: {
    cs: {
      [NS]: cs,
    },
    en: {
      [NS]: en,
    },
  },
};
